import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import * as moment from 'moment';
import { APIService } from 'src/app/services/api.service';
import { NotifierService } from 'src/app/services/notifier.service';
import { ActivatedRoute } from '@angular/router';
import {
  checkForVenuePermission,
  convertTimestamp,
  getENV,
  getRaceType,
} from '../../../../../../../_helpers/helpers';
import {
  buttonActions,
  typeBasedLocations,
} from '../post-race/harness-reports/components/race-reports/locations';
import { typesSelected } from '../../../../dash.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// declare $ for jQuery usage
declare let $: any;

interface NetworkDevice {
  instance: string;
  job: string;
  name: string;
  service: string;
  status: string;
  timestamp: string;
  status_message: string;
}

@Component({
  selector: 'app-grayhound-monitoring',
  templateUrl: './grayhound-monitoring.component.html',
  styleUrls: ['./grayhound-monitoring.component.css'],
})
export class GrayhoundMonitoringComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  // Race time update properties
  showRaceTimePopup: boolean = false;
  selectedRace: any = null;
  newRaceTime: { hour: number; minute: number } = { hour: 0, minute: 0 };
  hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutes: number[] = Array.from({ length: 60 }, (_, i) => i);
  hasUnsavedChanges: boolean = false;

  races: any = [];
  loading: boolean = false;
  eventsLoading: boolean = false;  events: any[] = [];
  headers: any = [
    {
      id: 'MinutesLeft',
      name: 'Time to Race',
      style: {
        width: '100px',
      },
      type: 'component',
      component: {
        name: 'MinutesLeft',
      },
    },
    {
      id: 'SquentialRaceOrderNumber',
      name: 'Race Number',
      style: {
        width: '100px',
      },
      type: 'string',
      filter: true,
      show: true,
    },
    {
      id: 'eventName',
      name: 'Venue',
      type: 'string',
      align: 'left',
      show: true,
      filter: true,
      link: {
        href: '/dash/venue-details',
        queryParamsKey: 'queryParamsVenue',
      },
    },
    {
      id: 'ExternalRaceId',
      name: 'Race ID',
      type: 'string',
      show: false,
      filter: true,
    },
    {
      id: 'RaceName',
      name: 'Race Name',
      align: 'left',
      type: 'string',
      // filter: true,
      show: true,
      link: {
        href: '/dash/race-details',
        queryParamsKey: 'queryParamsRace',
      },
    },
    {
      id: 'RaceState',
      name: 'Race Status',
      type: 'component',
      align: 'center',
      // filter: true,
      component: {
        name: 'RaceStatus',
      },
      show: true,
    },
    {
      id: 'status',
      name: 'Runner Status',
      type: 'component',
      // filter: true,
      component: {
        name: 'HorseStatusViewComponent',
      },
      show: true,
    },
    {
      id: 'buttonActions',
      name: 'Report Status',
      type: 'component',
      // filter: true,
      component: {
        name: 'RaceStatusViewComponent',
      },
      show: true,
    },
    {
      id: 'RaceTime',
      name: 'Race Time',
      type: 'string',
      show: true,
      datepicker: {
        class: 'datetimepicker',
      },
    },
    {
      id: 'DataQualityClass',
      name: 'Good/Bad Data',
      click: 'toggleGoodorBadData',
      type: 'component',
      component: {
        name: 'clickspan',
      },
    },
    {
      id: 'Operator',
      name: 'Operator',
      type: 'string',
      show: false,
    },
  ];
  config: any;
  statuses: { id: string; name: string }[] = [
    { name: 'PLANNED', id: 'PLANNED' },
    { name: 'DNS', id: 'DNS' },
    { name: 'DNT', id: 'DNT' },
    { name: 'DNF', id: 'DNF' },
    { name: 'DSQ', id: 'DSQ' },
    { name: 'OFFICIAL', id: 'OFFICIAL' },
    { name: 'FINISHED', id: 'FINISHED' },
    { name: 'PUBLISHED', id: 'PUBLISHED' },
    { name: 'ABANDONED', id: 'ABANDONED' },
    { name: 'FTF', id: 'FTF' },
    { name: 'SCR', id: 'SCR' },
    { name: 'L/SCR', id: 'L/SCR' },
    { name: 'FELL', id: 'FELL' },
    { name: 'DISTANCE', id: 'DISTANCE' },
    { name: 'RO', id: 'RO' },
    { name: 'BD', id: 'BD' },
    { name: 'LB', id: 'LB' },
    { name: 'LGO', id: 'LGO' },
    { name: 'LGT', id: 'LGT' },
  ];

  intervals: any = null;
  loopStatuses: any = {};

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private router: ActivatedRoute
  ) {
    this.config = this.router.snapshot.data['config'];
  }
  network_status: NetworkDevice[] = [];
  loadingNetworkStatus: boolean = false;

  async ngOnInit(): Promise<void> {
    // No initialization needed
  }

  ngOnDestroy(): void {
    this.clearIntervals();
  }

  startIntervals(): void {
    let formattedDate = moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD');
    let currentDate = moment().format('YYYY-MM-DD');

    this.callHeartbeatAction();

    this.callMylapsAction();

    this.status['completedRaces'] = 0;

    if (this.races.length == 0) {
      return;
    }

    if (!moment(formattedDate).isBefore(currentDate, 'day')) {
      this.callRacesAction();
      this.races.forEach((race) => {
        this.callRaceAction(race);
      });
      this.intervals = setTimeout(() => {
        this.startIntervals();
      }, 10000);
    }
    this.LoadRacesJson();
  }

  LoadRacesJson(): void {
    if (this.races.length > 0) {
      this.races.forEach((race) => {
        // this.getRaceJson(race);
        this.callOldRaceAction(race);
      });
    }
  }
  clearIntervals(): void {
    if (this.intervals) {
      clearTimeout(this.intervals);
      this.intervals = null;
    }
  }
  async ngAfterViewInit(): Promise<void> {
    this.date = moment().format('DD MMMM YYYY');
    $('.datetimepicker').val(this.date);
    $('.datetimepicker')
      .datepicker({
        autoclose: true,
        format: 'dd MM yyyy',
        orientation: 'bottom auto',
      })
      .on('changeDate', async (selected: any) => {
        this.date = $('.datetimepicker').val();
        this.clearIntervals();
        this.network_status = [];
        this.selected = null;
        await this.loadData();
      });

    setTimeout(async () => {
      await this.loadData();
    }, 100);
  }

  selectedVenue: string = 'ALL';
  venues: any[] = [];
  async loadData(): Promise<void> {
    this.races = [];
    this.date = $('.datetimepicker').val();
    let formattedDate = moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD');
    let currentDate = moment().format('YYYY-MM-DD');

    if (formattedDate) {
      try {
        this.eventsLoading = true;
        await this.loadEventsBasedOnDates(formattedDate);
        if (moment(formattedDate).isBefore(currentDate, 'day')) {
          this.LoadRacesJson();
        }
      } finally {
        this.eventsLoading = false;
      }
    }
  }

  async loadEventsBasedOnDates(date: string): Promise<boolean> {
    let raceTypes: any = localStorage.getItem('raceTypes');
    if (raceTypes) {
      raceTypes = JSON.parse(raceTypes);
    }
    let apiURL: string = `${
      this.config[getENV()].raceAPI
    }/event-list?formatted_date=${date}`;

    if (raceTypes && raceTypes.length > 0) {
      apiURL += `&race_types=${raceTypes.join(',')}&trial=${typesSelected['trial']}`;
    }

    let result: any = await this.apiService.getDataPromis(apiURL, {}, {});
    this.events = [];

    if (result.eventNames && result.eventNames.length > 0) {
      result.eventNames = result.eventNames.filter((event: any) => {
        return (event['external_venue_id'].startsWith('GR') || event['external_venue_id'] == '420') &&  checkForVenuePermission(event['external_venue_id']);
      });

      result.eventNames.forEach((event: any) => {
        event['id'] = event['external_event_id'];
        let raceType = getRaceType(event['external_venue_id']);
        event['raceType'] = raceType['raceTypeStr'];
        if (raceType['raceTypeStr'] == 'Thoroughbred Racing') {
          if (event['venue_name'] == 'Cranbourne') {
            event['venue_name'] = 'Cranbourne Turf';
          }
        }

        const jurisdiction = typeBasedLocations[event['raceType']]?.find(
          (jurisdiction: any) =>
            jurisdiction.Locations.some(
              (location: any) =>
                location.Name.toLowerCase() === event['venue_name'].toLowerCase()
            )
        );
        if (jurisdiction) {
          event['jurisdictionCode'] = jurisdiction.JurisdictionCode;
          event['stateCode'] = jurisdiction.State;
        }

        event['name'] = event['venue_name'];
        event['external_venue_id'] = event['external_venue_id'];
        event['external_event_id'] = event['external_event_id'];
        event['venue_name'] = event['venue_name'];
        event['date'] = date;
      });

      this.events = result.eventNames;
    }
    return true;
  }

  async loadRacesBasedOnEvent(event: any): Promise<boolean> {
    return new Promise(async (resolve: any) => {
      this.races = [];
      let apiURL: string = `${
        this.config[getENV()].raceAPI
      }/getracedetails?ExternalVenueId=${
        event['external_venue_id']
      }&ExternalEventId=${event['external_event_id']}`;

      let result: any = await this.apiService.getDataPromis(apiURL, {}, {});
      this.races = [];
      let raceDate = $('.datetimepicker').val();
      if (result && Array.isArray(result) && result.length > 0) {
        await this.getLoops(event['external_venue_id']);
        let raceType = getRaceType(event['external_venue_id'])['raceTypeStr'];
        result.forEach((race: any) => {
          race['loopsData'] = Array.from({ length: 10 }, () => ({
            passed: 0,
            failed: 0,
            status: 'blue',
            passedList: [],
            failedList: [],
          }));
          race.DataQualityClass = race.DataQuality
            ? 'green-circle'
            : 'red-circle';
          race['status'] = {
            PLANNED: 0,
            DNS: 0,
            DNT: 0,
            DNF: 0,
            DSQ: 0,
            OFFICIAL: 0,
            FINISHED: 0,
            PUBLISHED: 0,
            ABANDONED: 0,
            FTF: 0,
            SCR: 0,
            'L/SCR': 0,
            FELL: 0,
            DISTANCE: 0,
            RO: 0,
            BD: 0,
            LB: 0,
            LGO: 0,
            LGT: 0,
          };

          race['AnimalDetail'].forEach((runner: any) => {
            race['status'][runner?.RaceState?.toUpperCase() || 'PLANNED'] += 1;
          });
          // race['raceStatus'] = race['RaceState'] || 'PLANNED';
          race['RaceState'] = 'CLEANED';
          race['venue_name'] = event['venue_name'];
          race['buttonActions'] = [
            {
              slug: 'OR',
              status: 'PLANNED',
              actions: [],
            },
            {
              slug: 'PDF',
              status: 'PLANNED',
              actions: [],
            },
            {
              slug: 'CUST',
              status: 'PLANNED',
              actions: [],
            },
            {
              slug: 'TSD',
              status: 'PLANNED',
              actions: [],
            },
          ];
          let buttonActionsJSON = JSON.parse(JSON.stringify(buttonActions));
          buttonActionsJSON
            .filter((report: any) => {
              if (report.conditions) {
                const condition = report.conditions.find(
                  (c: any) => c.state === event['jurisdictionCode']
                );
                if (condition) {
                  const { key, equation, value } = condition.condition;
                  const raceValue = race[key];
                  switch (equation) {
                    case 'equals':
                      return raceValue === value;
                    case 'not equals':
                      return raceValue !== value;
                    default:
                      return true;
                  }
                }
                return true;
              }
              return true;
            })
            .forEach((report: any) => {
              if (
                (report.states == 'ALL' ||
                  report.states.includes(event['jurisdictionCode']) ||
                  report.states.includes(event['stateCode'])) &&
                (!report.type || report.type == raceType)
              ) {
                let reportStatus = race['ReportStatus'].find((report_: any) => {
                  return report_['StepType'] == report['action'];
                });
                let action = race['buttonActions'].find(
                  (buttonAction: any) => buttonAction.slug == report['slug']
                );

                if (reportStatus) {
                  action['actions'].push({
                    name: report['name'],
                    status: reportStatus['StepCompletionStatus'].toUpperCase(),
                    comment: reportStatus['Comments'] || '',
                  });
                } else {
                  action['actions'].push({
                    name: report['name'],
                    status: 'PLANNED',
                    comment: '',
                  });
                }
              }
            });

          race['buttonActions'].forEach((action: any) => {
            let success = action['actions'].find((action_: any) => {
              return action_['status'] == 'COMPLETED';
            });
            let failed = action['actions'].find((action_: any) => {
              return action_['status'] == 'FAILED';
            });
            if (failed) {
              action['status'] = 'FAILED';
            } else if (success) {
              action['status'] = 'COMPLETED';
            } else {
              action['status'] = 'PLANNED';
            }
          });

          race['eventName'] = event['name'];
          race['eventDate'] = $('.datetimepicker').val();
          race['RaceTimeStr'] = race['RaceTime'];
          race['RaceTime'] = convertTimestamp(
            race['RaceTime'],
            event['venue_state'],
            true
          );
          race['queryParamsVenue'] = {
            event_id: race['ExternalEventId'],
            venue_id: race['ExternalVenueId'],
            date: race['eventDate'],
            event_name: race['eventName'],
          };
          race['queryParamsRace'] = {
            race_id: race['ExternalRaceId'],
            event_id: race['ExternalEventId'],
          };
          race['MinutesLeft'] = this.calculateMinutesLeft(
            raceDate,
            race['RaceTime']
          );
          // race.loops = this.processLoopData(race);
          race.pdfStatus = this.calculatePdfStatus(race);
        });
        this.races = [...this.races, ...result];
      }
      resolve(true);
    });
  }

  calculateMinutesLeft(raceDate, raceTimeStr) {
    let raceHour = parseInt(raceTimeStr.substring(0, 2));
    let raceMinute = parseInt(raceTimeStr.substring(3, 5));
    let raceDateTime = moment(raceDate, 'DD MMMM YYYY').set({
      hour: raceHour,
      minute: raceMinute,
      second: 0,
      millisecond: 0,
    });
    let currentTime = moment();
    let minutesLeft = raceDateTime.diff(currentTime, 'minutes');
    return minutesLeft;
  }

  // Add this property to store the state lookup
  stateLookup: {
    [key: string]: {
      raceState: string;
      raceNumber: any;
      segments: { [key: number]: number };
    };
  } = {};

  async getRaceJson(race: any): Promise<any> {
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;
    const payload: any = {
      action: 'generate_race_json',
      race_id: race.ExternalRaceId,
    };
    try {
      let response: any = await this.apiService.postDataPromis(
        apiURL,
        payload,
        {}
      );
      const parsedResponse = JSON.parse(response.response);

      // Create segment counts dictionary
      const segmentCounts: { [key: number]: number } = {};

      // Count entrants for each segment
      if (parsedResponse.RaceEntrants) {
        parsedResponse.RaceEntrants.forEach((entrant: any) => {
          if (entrant.sectional_mylaps) {
            entrant.sectional_mylaps.forEach((section: any) => {
              const segmentNumber = section.SegmentNumber;
              segmentCounts[segmentNumber] =
                (segmentCounts[segmentNumber] || 0) + 1;
            });
          }
        });
      }

      // Update the state lookup
      // this.stateLookup[parsedResponse.ExternalRaceID] = {
      //   raceState: parsedResponse.RaceState,
      //   segments: segmentCounts,
      //   raceNumber: parsedResponse.RaceNumber
      // };
      // console.log(parsedResponse.RaceNumber)
      const raceIndex = parsedResponse.RaceNumber - 1;
      if (raceIndex >= 0 && raceIndex < this.races.length) {
        this.races[raceIndex].RaceState = parsedResponse.RaceState;

        // Determine the number of loops based on segment counts
        const numLoops = Object.keys(segmentCounts).length;

        for (let i = 0; i < numLoops; i++) {
          const segment = (i + 1).toString();
          this.races[raceIndex].loopsData[i].passed = segmentCounts[segment] || 0;
          if (segmentCounts[segment] > 0) {
            this.races[raceIndex].loopsData[i].status = 'green';
          }
        }

        // this.races[parsedResponse.RaceNumber - 1].loopsData[]
      } else {
        console.warn(`Race number ${parsedResponse.RaceNumber} is out of range.`);
      }
      return parsedResponse;
    } catch (error) {
      console.error('Error getting race json:', error);
      throw error;
    }
  }

  async callHeartbeatAction(): Promise<any> {    const apiURL =
      'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
    const url = `${apiURL}/greyhound-monitor?action=heartbeat`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});
      if (response.status == '1' || response.s == '1') {
        this.status['heartbeat'] = 'alive';
      } else {
        this.status['heartbeat'] = 'down';
      }
    } catch (error) {
      this.status['heartbeat'] = 'down';
      console.error('Error calling heartbeat action:', error);
    }
  }

  status: any = {
    lap: 'NoConnection',
    heartbeat: 'down',
  };
  async callMylapsAction(): Promise<any> {    const apiURL =
      'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
    const url = `${apiURL}/greyhound-monitor?action=mylaps`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});
      if (response.status == '1' || response.s == '1') {
        this.status['lap'] = response.connection_status || 'NoConnection';
      } else {
        this.status['lap'] = 'NoConnection';
      }
    } catch (error) {
      this.status['lap'] = 'NoConnection';
      console.error('Error calling mylaps action:', error);
    }
  }

  async callRacesAction(): Promise<any> {
    const apiURL =
      'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
    const url = `${apiURL}/greyhound-monitor?action=races`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});
      if (response.status == '1' || response.s == '1') {
        const races = response.races || [];
        this.races.forEach((race: any) => {
          let race_ = races.find((race_: any) => {
            return race_['raceid'] == race['ExternalRaceId'];
          });
          if (race_) {
            if (race['status'] == 'FINISHED') {
              this.status['completedRaces'] += 1;
            }
            race['RaceState'] = race_['status'].toUpperCase();
          }
        });
      } else {
        throw new Error('Failed to retrieve data');
      }
    } catch (error) {
      console.error('Error calling races action:', error);
      throw error;
    }
  }

  getTotalLoops(race: any) {
    if(!race['loopsData']) {
      return [];
    }
    return race['loopsData'].filter((loop: any) => loop.status !== 'blue');
  }

  getPassedLoops(race: any) {
    if(!race['loopsData']) {
      return [];
    }
    return race['loopsData'].filter((loop: any) => loop.status === 'green');
  }

  getFailedLoops(race: any) {
    if(!race['loopsData']) {
      return [];
    }
    return race['loopsData'].filter((loop: any) => loop.status === 'red');
  }

  async callRaceAction(race: any): Promise<any> {
    const apiURL =
      'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
    const url = `${apiURL}/greyhound-monitor?action=race&externalRaceId=${race.ExternalRaceId}`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});

      if (response.status == '1' || response.s == '1') {
        // Set pulse status directly from API response based on race state and starting pulse
        if (
          race.RaceState === 'SCHEDULED' ||
          race.RaceState === 'PLANNED' ||
          race.RaceState === 'CLEANED'
        ) {
          // Race not yet armed, pulse should be blue
          race.pulseStatus = 'blue';
        } else if (
          race.RaceState === 'ARMED' ||
          race.RaceState === 'RUNNING' ||
          race.RaceState === 'FINISHED' ||
          race.RaceState === 'OFFICIAL'
        ) {
          // Race is armed or beyond, check if startingpulse was received
          if (response.startingpulse || race['StartTime']) {
            race.pulseStatus = 'green';
          } else {
            race.pulseStatus = 'red';
          }
        } else {
          // Default for any other states
          race.pulseStatus = 'blue';
        }

        if (race['StartTime']) {
          race.pulseStatus = 'green';
        }

        if (response.runners && response.runners.length > 0) {
          race.AnimalDetailLoops = response.runners;
          this.processLoopData(race);
          race['status'] = {
            PLANNED: 0,
            DNS: 0,
            DNT: 0,
            DNF: 0,
            DSQ: 0,
            RUNNING: 0,
            OFFICIAL: 0,
            FINISHED: 0,
            PUBLISHED: 0,
            ABANDONED: 0,
            FTF: 0,
            SCR: 0,
            'L/SCR': 0,
            FELL: 0,
            DISTANCE: 0,
            RO: 0,
            BD: 0,
            LB: 0,
            LGO: 0,
            LGT: 0,
          };

          response.runners.forEach((runner: any) => {
            race['status'][runner?.status?.toUpperCase() || 'PLANNED'] += 1;
          });
        }
      }
    } catch (error) {
      console.error(
        `Error calling race action for ${race.ExternalRaceId}:`,
        error
      );
      throw error;
    }
  }

  async callOldRaceAction(race: any): Promise<any> {
    const apiURL =
      'https://50b3p4zwm3.execute-api.ap-southeast-2.amazonaws.com/tsd-prod-api';
    const url = `${apiURL}/greyhound-monitor?action=old_race&externalRaceId=${race.ExternalRaceId}`;
    try {
      const response = await this.apiService.getDataPromis(url, {}, {});

      if (response.status == '1' || response.s == '1') {
        if (response.runners && response.runners.length > 0) {
          race.AnimalDetailLoops = response.runners;
          this.processLoopData(race);
        }
      }
    } catch (error) {
      console.error(
        `Error calling race action for ${race.ExternalRaceId}:`,
        error
      );
      throw error;
    }
  }

  loops: { [k: string]: number[] } = {};
  async getLoops(venue_id: string) {
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;
    let payload: any = {
      action: 'gr_loops',
      venue_id: venue_id,
    };
    let result: any = await this.apiService.postDataPromis(apiURL, payload, {});
    if (result.status == '1' || result.s == '1') {
      this.loops = result.loops;
    }
  }

  formatAnimalList(animals: any[]): string {
    if (!animals || !animals.length) return '';
    return animals.map((a) => '#' + a.animalid).join(' ');
  }

  processLoopData(race: any) {
    if (
      race.AnimalDetailLoops &&
      Array.isArray(race.AnimalDetailLoops) &&
      this.loops[race.RaceLength] &&
      this.loops[race.RaceLength].length > 0
    ) {
      this.loops[race.RaceLength].forEach(
        (loop_number: number, index: number) => {
          let animalsPassed: any = race['AnimalDetailLoops'].filter(
            (runner: any) => {
              return runner.passed[index] != undefined && runner.passed[index] != null;
            }
          );

          let animalsFailed: any = race['AnimalDetailLoops'].filter(
            (runner: any) => {
              return !(runner.passed[index] != undefined && runner.passed[index] != null);
            }
          );

          let loop = race['loopsData'][index];

          loop.passed = animalsPassed.length;
          loop.failed = animalsFailed.length;
          loop.passedList = animalsPassed;
          loop.failedList = animalsFailed;

          if (animalsFailed.length > 0 && animalsPassed.length == 0) {
            if (race?.RaceState === 'SCHEDULED') {
              loop.status = 'orange';
            } else {
              loop.status = 'red';
            }
          } else if (animalsPassed.length > 0 && animalsFailed.length == 0) {
            loop.status = 'green';
          } else if (animalsPassed.length > 0 && animalsFailed.length > 0) {
            loop.status = 'yellow';
          } else if (animalsPassed.length == 0 && animalsFailed.length == 0) {
            loop.status = 'orange';
          }
        }
      );
    } else {
      if (
        this.loops[race.RaceLength] &&
        this.loops[race.RaceLength].length > 0
      ) {
        this.loops[race.RaceLength].forEach(
          (loop_number: number, index: number) => {
            let loop = race['loopsData'][index];
            loop.status = 'orange';
          }
        );
      } else {
        this.loops[race.RaceLength] = [];
      }
    }
  }

  calculatePdfStatus(race: any): string {
    const allLoopsGood = race.loops?.every((loop) => loop.status === 'green');
    return allLoopsGood ? 'green' : 'blue';
  }

  getRaceStatusClass(race: any): string {
    if (!race?.RaceState) return '';
    return race.RaceState.toLowerCase();
  }

  getLoopStatusClass(loop: any): string {
    return `status-${loop.status}`;
  }

  getLoopTooltip(loop: any): string {
    const statusText = {
      green: 'Loop completed',
      yellow: 'Minor issue',
      red: 'Major issue',
      blue: 'Loop not used',
    };
    return statusText[loop.status] || '';
  }

  getPulseStatusClass(race: any): string {
    // Default to neutral if pulseStatus is not set
    return `status-${race.pulseStatus || 'blue'}`;
  }

  getPulseTooltip(race: any): string {
    const tooltips = {
      blue: 'Awaiting start pulse - race not yet armed',
      green: `Start pulse received - ${race['RaceTime']}`,
      red: 'Start pulse missing after race armed',
    };
    return tooltips[race.pulseStatus] || 'Start pulse status unknown';
  }

  getPdfStatusClass(race: any): string {
    return `status-${race.pdfStatus}`;
  }

  date: string = null;
  selected: any = null;

  async selectEvent(event: any) {
    if (!event) return;
    // Set selected flag on chosen event
    this.races = [];
    event.selected = true;

    this.notifier.loading(true);
    this.selected = event;
    try {
      await this.loadRacesBasedOnEvent(event);
      if (this.races && this.races.length > 0) {
        this.races = this.races.sort((a: any, b: any): number => {
          return a['SquentialRaceOrderNumber'] - b['SquentialRaceOrderNumber'];
        });
        this.startIntervals();
      }
    } catch (error) {
      console.error('Error loading races:', error);
      this.notifier.alert('Error', '', 'Failed to load races. Please try again.', 'error', 5000);
    } finally {
      this.notifier.loading(false);
    }
    this.loadNetworkStatus(event);
  }

  async loadNetworkStatus(event: any): Promise<void> {
    if (!event) return;
    this.loadingNetworkStatus = true;
    try {
      const monitoringUrl = `${this.config['prod'].raceAPI}/prepare-monitoring?event_id=${event.external_event_id}`;
      const monitoringResult = await this.apiService.getDataPromis(monitoringUrl, {}, {});
      this.loadingNetworkStatus = false;
      if (monitoringResult.status === 'success' && monitoringResult.events[event.external_event_id]) {
        const eventDetails = monitoringResult.events[event.external_event_id];
        this.network_status = eventDetails.network_status || [];
      } else {
        this.notifier.alert(
          'Error',
          '',
          `Failed to load network status for ${event.venue_name}`,
          'error'
        );
        this.network_status = [];
      }
    } catch (error) {
      this.notifier.alert(
        'Error',
        '',
        `Error loading network status for ${event.venue_name}`,
        'error'
      );
      this.network_status = [];
    }
  }

  getDeviceStatus(status: string): 'success' | 'failed' {
    return status === '1' ? 'success' : 'failed';
  }

  // Helper method to check if race time can be edited
  isRaceTimeEditable(race: any): boolean {
    // Cannot edit race time if race is in these states
    const unEditableStates = ['FINISHED', 'PUBLISHED', 'OFFICIAL'];
    return !unEditableStates.includes(race.RaceState);
  }

  // Race time popup methods
  openRaceTimePopup(race: any) {
    if (!this.isRaceTimeEditable(race)) {
      this.notifier.alert(
        'Error',
        '',
        'Cannot edit race time in current state',
        'error',
        5000
      );
      return;
    }

    this.selectedRace = race;
    const [hour, minute] = race.RaceTime.split('H').map(Number);
    this.newRaceTime = { hour, minute };
    this.showRaceTimePopup = true;
  }

  closeRaceTimePopup() {
    this.showRaceTimePopup = false;
    this.selectedRace = null;
    this.newRaceTime = { hour: 0, minute: 0 };
  }

  addMinutes(minutes: number) {
    let time = moment({
      hour: this.newRaceTime.hour,
      minute: this.newRaceTime.minute,
    });
    time.add(minutes, 'minutes');
    this.newRaceTime.hour = time.hour();
    this.newRaceTime.minute = time.minute();
  }

  resetRaceTIme() {
    let raw = this.convertRaceTime(this.selectedRace.RaceTimeStr);
    const [hour, minute] = raw.split('H').map(Number);
    this.newRaceTime = { hour, minute };
  }

  updateRaceTime() {
    if (this.selectedRace) {
      let raw = this.convertRaceTime(this.selectedRace.RaceTimeStr);
      const [hour, minute] = raw.split('H').map(Number);
      const newRaceTime = `${this.newRaceTime.hour
        .toString()
        .padStart(2, '0')}H${this.newRaceTime.minute
        .toString()
        .padStart(2, '0')}`;

      if (this.newRaceTime.hour == hour && this.newRaceTime.minute == minute) {
        this.selectedRace.RaceTime = newRaceTime;
        this.selectedRace.timeChanged = false;
        this.selectedRace.RaceTimeHTML = newRaceTime;
        this.selectedRace.diffTime = 0;
      } else {
        const originalTime = moment({ hour, minute });
        const newTime = moment({
          hour: this.newRaceTime.hour,
          minute: this.newRaceTime.minute,
        });
        const diff = newTime.diff(originalTime, 'minutes');
        const diffFormatted = diff >= 0 ? `+${diff}m` : `${diff}m`;
        this.selectedRace.RaceTimeHTML = `${newRaceTime} <span class='fw-bold'>${diffFormatted}</span>`;
        this.selectedRace.RaceTime = newRaceTime;
        this.selectedRace.diffTime = diff;
        this.selectedRace.timeChanged = true;
        this.hasUnsavedChanges = true;
      }
      this.closeRaceTimePopup();
    }
  }

  // Submit race time updates to the server
  async submitRaceTimeUpdates() {
    if (!this.races || this.races.length === 0 || !this.selected) {
      this.notifier.alert('Warning', '', 'No races available to update', 'warning', 3000);
      return;
    }

    // Get only races with time changes that are editable
    const racesWithChanges = this.races.filter(race => race.timeChanged && this.isRaceTimeEditable(race));

    if (racesWithChanges.length === 0) {
      this.notifier.alert('Warning', '', 'No race time changes to submit', 'warning', 3000);
      return;
    }

    this.notifier.loading(true);

    try {
      // Prepare updated races with proper datetime format using rawRaceTime and diffTime
      const updatedRaces = racesWithChanges.map(race => {
        // Use the raw time and add the time difference to get the new time
        const momentObj = moment(race.RaceTimeStr, 'YYYY-MM-DD-HH:mm:ss');
        // Apply the time difference
        momentObj.add(race.diffTime, 'minutes');

        // Format for API: YYYY-MM-DD HH:MM:SS
        const formattedDate = moment(this.date, 'DD MMMM YYYY').format('YYYY-MM-DD');
        const formattedTime = momentObj.format('HH:mm:00');
        const scheduledStartTime = `${formattedDate} ${formattedTime}`;

        return {
          race_id: race.ExternalRaceId,
          scheduled_start_time: scheduledStartTime
        };
      });

      // Make the API call to update race times
      const apiURL = `${this.config[getENV()].raceAPI}/flask-operations`;
      const payload = {
        action: "race_scheduled_times",
        races: updatedRaces
      };

      const result = await this.apiService.postDataPromis(apiURL, payload, {});

      if (result && result.status === "1") {
        // Reset timeChanged flag for successfully updated races
        if (result.updated_races && result.updated_races.length > 0) {
          const updatedRaceIds = result.updated_races.map(r => r.race_id);

          this.races.forEach(race => {
            if (updatedRaceIds.includes(race.ExternalRaceId)) {
              // Update rawRaceTime to the new time after successful submission
              const momentObj = moment(race.RaceTimeStr, 'YYYY-MM-DD-HH:mm:ss');
              momentObj.add(race.diffTime, 'minutes');
              race.RaceTimeStr = momentObj.format('YYYY-MM-DD-HH:mm:ss');
              race.rawRaceTime = race.RaceTimeStr;

              // Reset the display
              race.timeChanged = false;
              race.diffTime = 0;

              // Update display to show the new time without the diff indicator
              const raceTimeFormatted = race.RaceTime.split('H');
              race.RaceTimeHTML = `${raceTimeFormatted[0]}H${raceTimeFormatted[1]}`;
            }
          });

          this.hasUnsavedChanges = false;
          this.notifier.alert(
            'Success',
            '',
            `Successfully updated ${result.updated_races.length} race time(s)`,
            'success',
            5000
          );
        }

        // Check if there were any failures
        if (result.failed_races && result.failed_races.length > 0) {
          const failedRaceIds = result.failed_races.map(f => f.race_id).join(', ');
          const mainReason = result.failed_races[0].reason || 'Unknown error';

          this.notifier.alert(
            'Partial Success',
            '',
            `Updated ${result.total_updated || 0} races. Failed to update ${result.total_failed || result.failed_races.length} races (${failedRaceIds}). Reason: ${mainReason}`,
            'warning',
            7000
          );
        }
      } else {
        // Handle error response
        const errorMessage = result.error || 'Unknown error occurred';
        this.notifier.alert('Error', '', `Failed to update race times: ${errorMessage}`, 'error', 5000);
      }
    } catch (error) {
      console.error('Error updating race times:', error);
      this.notifier.alert('Error', '', 'An error occurred while updating race times', 'error', 5000);
    } finally {
      this.notifier.loading(false);
    }
  }

  convertRaceTime(time: string): string {
    if (!this.selected) return time;
    return convertTimestamp(time, this.selected.venue_state);
  }

  handleRaceTimeClick(race: any) {
    this.openRaceTimePopup(race);
  }
}

export enum RaceStatusEN {
  SCHEDULED = 'SCHEDULED',
  ARMED = 'ARMED',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  ABANDONED = 'ABANDONED',
}
